var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FieldItem",
    { attrs: { id: _vm.id, label: _vm.$t(_vm.fieldConfig.label) } },
    [
      _c(
        "ElSelect",
        {
          staticClass: "search-preference__select",
          attrs: {
            placeholder: _vm.$t(_vm.fieldConfig.label),
            size: "small",
            disabled: _vm.store.settingValues.automatic,
          },
          on: { change: _vm.onChange },
          model: {
            value: _vm.fieldValue,
            callback: function ($$v) {
              _vm.fieldValue = $$v
            },
            expression: "fieldValue",
          },
        },
        _vm._l(_vm.store.gapCostsOptions, function (option) {
          return _c("ElOption", {
            key: option.value,
            attrs: { label: option.label, value: option.value },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }